import { Root } from './Root/root';
import { Thread } from './Thread/thread';

export const components = {
  Root,
  Thread,
};
